import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent implements OnInit {
    @Input() centerVertically?: boolean;
    @Input() after?: number;
    @Input() noMargin?: number;
    @Input() alignLeft?: boolean = false;
    @Input() fixed?: boolean = false;

    timeout: boolean = false;

    constructor() {}

    ngOnInit() {
        if (this.after) {
            this.timeout = true;
            setTimeout(() => {
                this.timeout = false;
            }, this.after);
        }
    }
}
